import { EyeNoneIcon, EyeOpenIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useKestrel } from 'features/kestrelViewer'
import { KestrelCommands } from 'features/kestrelViewer/types/KestrelCommands'
import React, { FC } from 'react'
import styled from 'styled-components'
import { KVAnnotation } from 'types'

const StyledEyeClosedIcon = styled(EyeNoneIcon)`
  color: lightgray;
  &:hover {
    color: white;
  }
`

const StyledEyeOpenIcon = styled(EyeOpenIcon)`
  color: lightgray;
  &:hover {
    color: white;
  }
`

export const ToggleAnnotationVisibilityButton: FC<{
  annotation: KVAnnotation
}> = ({ annotation }) => {
  const { updateAnnotation, updateHistoricalAnnotations, sendKVCommand } =
    useKestrel()

  const toggleAnnotationVisibility = (e: React.MouseEvent) => {
    e.stopPropagation()
    const isVisible = annotation.visible

    if (annotation.historical) {
      updateHistoricalAnnotations(
        annotation,
        'annotationVisible',
        (a: KVAnnotation) => {
          a.visible = !isVisible
          return a
        },
        !isVisible
      )
    } else if (!annotation.historical) {
      updateAnnotation(
        annotation,
        'annotationVisible',
        (a: KVAnnotation) => {
          a.visible = !isVisible
          return a
        },
        !isVisible
      )
    }
    if (annotation.geometry?.kind === 'polygon' && sendKVCommand) {
      sendKVCommand({
        command: KestrelCommands.UPDATE_SURFACE_AREA,
        surfaceAreaId: annotation.id,
        surfaceAreaVisible: !isVisible,
      })
    }
  }

  return (
    <TooltipWrapper
      label={annotation.visible ? 'Hide annotation' : 'Show annotation'}
      side='top'>
      <div
        style={{ cursor: 'pointer' }}
        onClick={(e) => toggleAnnotationVisibility(e)}>
        {annotation.visible ? (
          <StyledEyeOpenIcon width={18} height={18} />
        ) : (
          <StyledEyeClosedIcon width={18} height={18} />
        )}
      </div>
    </TooltipWrapper>
  )
}
